import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { UserPrefsInfo } from '../../types/generated/UserPrefsInfo';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SetUserPrefsMutationVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
  userPrefs: Types.UserPrefsInput;
}>;


export type SetUserPrefsMutation = { __typename?: 'Mutation', setUserPrefs: { __typename?: 'UserPrefs', id: string, privateCommentsEnabled?: boolean | null, timeDisplayFormat: Types.TimeDisplayFormat, previewEnvironmentBanner?: boolean | null, transcriptionsLanguage?: string | null, hasTranscriptionConsent?: boolean | null, downloadSettings: { __typename?: 'UserPrefsDownloadSettings', locations?: Array<string> | null, shouldImport?: boolean | null }, exploreTemplatesBannerSettings: { __typename?: 'UserPrefsExploreTemplatesBannerSettings', shouldShowExploreTemplatesBanner: boolean } } };


export const SetUserPrefs = /*#__PURE__*/ gql`
    mutation SetUserPrefs($userId: ID!, $userPrefs: UserPrefsInput!) {
  setUserPrefs(userId: $userId, userPrefs: $userPrefs) @client {
    ...UserPrefsInfo
  }
}
    ${UserPrefsInfo}` as unknown as DocumentNode<SetUserPrefsMutation, SetUserPrefsMutationVariables>;

          

          export const useSetUserPrefsMutation = (options?:MutationHookOptions<SetUserPrefsMutation, SetUserPrefsMutationVariables>) => useMutation(SetUserPrefs, options);
          

          export type SetUserPrefsMutationOptions = MutationHookOptions<SetUserPrefsMutation, SetUserPrefsMutationVariables>;

          

          export type SetUserPrefsMutationResult = ReturnType<typeof useSetUserPrefsMutation>[1];

          
